import RotatePhone from "./RotatePhone"

export default RotatePhone
